import React from 'react';
import { ImageListItem, Dialog } from '@mui/material';
import { width } from '@mui/system';

const SingleImageDialog = ({ imageSrc }) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <ImageListItem onClick={handleClickOpen} sx={{ cursor: 'pointer' }}>
                <img src={`${imageSrc}`} alt={''} loading="lazy" />
            </ImageListItem>
            <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
                <img src={`${imageSrc}`} alt={''} loading="lazy" />
            </Dialog>
        </>
    );
};

export default SingleImageDialog;
